import React from 'react';
import FileRow from './FileRow';

export default function FileList({ httpParams, files, handleRemoveFile, isEditable, doNotRemoveFiles, listSectionId }) {
  if (!files.length) return null;

  const hasUploadDates = () => {
    return !!files.find(file => file.created);
  };

  let idObj = {};
  if (listSectionId) idObj.id = listSectionId;

  return (
    <section {...idObj} className='ect-file-picker__files-list'>
      <div className='ect-file-picker__files-header'>
        <div className='ect-file-picker__col_name'>File name</div>
        {hasUploadDates() && <div className='ect-file-picker__col_upload-date'>Upload date</div>}
        {hasUploadDates() && <div className='ect-file-picker__col_download'>Download</div>}
        {isEditable && !doNotRemoveFiles && <div className='ect-file-picker__col_remove'>Remove</div>}
      </div>
      {files.map((file, index) => (
        <FileRow
          key={index}
          file={file}
          index={index}
          isEditable={isEditable}
          httpParams={httpParams}
          handleRemoveFile={handleRemoveFile}
          doNotRemoveFiles={doNotRemoveFiles}
        />
      ))}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Components/FilePicker/FileList.jsx